import React from 'react';
import { localize } from 'core/localization';
import { Container } from './PoolCounter.styled';

type PoolCounterProps = {
  index: number;
  total: number;
};

export const PoolCounter = ({ index, total }: PoolCounterProps) => (
  <Container>
    {localize('[question pool counter caption]', { index, total }, `${index} out of ${total}`)}
  </Container>
);

export default PoolCounter;
